import 'style-loader!./registration-pre.component.scss';
import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { AlertService } from 'app/theme/services/alert.service';
import { MatIconRegistry, DateAdapter, MatDatepicker } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { User, Task, IKeyboard } from 'app/theme/models/user.model';
import { ChannelService } from 'app/theme/services/channel.service';
import { UserService } from 'app/theme/services/user.service';
import { LanguageService } from 'app/theme/services/language.service';
import { CodiceFiscaleService } from 'app/theme/services/codiceFiscale.service';
import { IFindConsumerResponse, IInfoUserResponse,ICacheStatusResponse, IFindCFResponse } from 'app/theme/models/response';
import { DataService } from 'app/theme/services/data.service';
import { CustomerService } from 'app/theme/services/customer.service';
import { CardService } from 'app/theme/services/card.service';
import { ThemeSpinnerService } from 'app/theme/services/themeSpinner.service';
import { ElementRef, ViewChild } from '@angular/core';
import { debug } from 'util';

@Component({
	selector: 'registration-pre',
	templateUrl: './registration-pre.component.html',
	encapsulation: ViewEncapsulation.None

})
export class CreateAccountComponent implements OnInit {
	@Output('done') done: EventEmitter<boolean> = new EventEmitter();
	@Output('forgetBCNumber') forgetBCNumber: EventEmitter<boolean> = new EventEmitter();

	//club
	hoBC: boolean;
	codTessera: string = '';
	cartRegExp = new RegExp(/^([0-9]{13}$)/m);
	//customer 
	user: User = new User();
	nonHoCf: boolean;
	btnTitle: string;
	minDate: Date;
	maxDate: Date;
	activedMaintenanceStibo: boolean = false;
    activedMaintenanceDate: string = '';
	CountryList: Array<any>;
	saved: boolean;
	drivenName: string;
	movedIn: boolean;
	Labels: any;
	alerts: any;
	source;
	nexturl:  string = '';
	topIframe: string = '';

	public constructor(
		protected adapter: DateAdapter<any>,
		protected _alertService: AlertService,
		protected _channelService: ChannelService,
		protected _userService: UserService,
		protected _customerService: CustomerService,
		protected _langService: LanguageService,
		protected _dataService: DataService,
		protected _cardService: CardService,
		protected _themeSpinner: ThemeSpinnerService,
		protected router: Router,
		protected cfService: CodiceFiscaleService,
		iconReg: MatIconRegistry,
		sanitizer: DomSanitizer,
	) {
		iconReg.addSvgIcon("carta", sanitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_carta.svg'))
		iconReg.addSvgIcon("exit", sanitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_exit.svg'))
		iconReg.addSvgIcon("save", sanitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_save.svg'))

	}

    //CR ACCESSIBILITà GESTIONE AUTOCOMPLETE START
    ngAfterViewInit() {
        const fields = ['cap', 'city', 'province', 'address', 'civico','via','residence'];
        const disableForAll = this.source === 'tablet' || this.source === 'totem' || this.source === 'tablet-new' || this.source === 'totem-new';
        
        if (disableForAll) {
            // Converte NodeList in un array e applica la funzione
            Array.from(document.querySelectorAll('input')).forEach((input: HTMLInputElement) => {
            this.disableAutocomplete(input.id); // Usa l'id se disponibile
            });
        
        } else {
            // Disattiva solo per i campi specificati
            fields.forEach(field => this.disableAutocomplete(field));
        }
        }
      
    
        private disableAutocomplete(elementId: string): void {
            const inputElement = document.getElementById(elementId) as HTMLInputElement;
            let sottostringa = "mat-";        

            if (!elementId.toLowerCase().includes(sottostringa.toLowerCase())) {
                if (inputElement) {
                    // Disattiva tutti gli attributi legati all'autocomplete
                    inputElement.setAttribute('autocomplete', 'new-password'); // Alternativa più efficace a "off"
                    inputElement.setAttribute('autocorrect', 'off');
                    inputElement.setAttribute('autocapitalize', 'off');
                    inputElement.setAttribute('spellcheck', 'false');
                    
                    // Cambia dinamicamente il nome e l'ID per evitare suggerimenti memorizzati
                    const newName = elementId + '_' + new Date().getTime();
                    inputElement.setAttribute('name', newName);
                    inputElement.setAttribute('id', newName);
        
                    // Disattiva la gestione automatica degli indirizzi di Chrome e password manager
                    inputElement.setAttribute('data-lpignore', 'true'); // LastPass
                    inputElement.setAttribute('data-form-type', 'other');
                    inputElement.setAttribute('aria-autocomplete', 'none');
                
                    // Nasconde suggerimenti tramite CSS inline
                    // inputElement.style.setProperty('display', 'inline-block', 'important');
                    inputElement.style.setProperty('position', 'relative', 'important');
                    inputElement.style.setProperty('z-index', '9', 'important'); //Abbastanza da sovrapporre i campi non abbastanza da sovrapporre il resto
                    
                    // Ritarda la modifica dell'ID per "ingannare" il browser
                    setTimeout(() => {
                        inputElement.setAttribute('id', elementId);
                    }, 1000);  
                }              
            }
        }  

		@ViewChild('mainContent') mainContent: ElementRef | null = null;

  skipToMain(event: Event) {
    event.preventDefault(); // Evita il comportamento predefinito del link
    
    if (this.mainContent) {
      setTimeout(() => {
        this.mainContent.nativeElement.focus();
      }, 0); // Timeout per garantire che Angular abbia reso l'elemento visibile
    }
  }
    //CR ACCESSIBILITà GESTIONE AUTOCOMPLETE END

	/* --------------------- */

	public ngOnInit() {
		this.saved = false;
		this.movedIn = false;
		this.hoBC = true;
		this.nonHoCf = false;
		this._userService.customerid = "";
		this._userService.key= "";
		this._langService.translatePageIndex(1).subscribe((labels) => {
			this.Labels = labels;
		})
		this._channelService.getSource()
			.subscribe(theme => {
				this.drivenName = theme;
				if (this.drivenName == "totem" || this.drivenName == "totem-new") {
					setTimeout(() => {
						this.createKeyboard();
					}, 0);
				}
			});


		this._channelService.getSource().subscribe((source: string) => {
			if (source) {
				this.source = source;
			}
			if (source == "drive-new") {
				this.topIframe = 'modal-iframe';
			}
		})

		this._channelService.getNextUrl().subscribe((nexturl) => {
			this.nexturl = nexturl;
		  })

		this._langService.subscribeAlerts().subscribe((alerts) => {
			if (alerts) {
				this.alerts = alerts;
			}
		})
		this._langService.getUsedLanguage().subscribe((lang) => {
			switch (lang) {
				case 'ita': this.adapter.setLocale('ita'); break;
				case 'eng': this.adapter.setLocale('eng'); break;
				default: this.adapter.setLocale('ita'); break;
			}
		})

		var now = new Date()
		this.maxDate = new Date(now.getFullYear() - 18, now.getMonth(), now.getDate())
		this.minDate = new Date(now.getFullYear() - 120, now.getMonth() + 1, now.getDay());

		this._customerService.CacheStatus( )
		.then((data: ICacheStatusResponse) => {
			 
			 
			if(data.maintenanceActived=== 'Y'){
				this.activedMaintenanceDate=data.maintenanceActivedDate;
				this.activedMaintenanceStibo=true;
				let refDialog =this._alertService.showModalAlertWarning(this.Labels.stiboRegMaintenance, `
				<div class='text-center'>
				${this.Labels.stiboRegMaintenance1}<br><br>
				${this.Labels.stiboRegMaintenance2}<br>
				</div>
				`, null,'X');
				this._themeSpinner.hide("body", "body");

				 
			}
			
			 

		}).catch((error) => {
			//console.error(error);
			//this._router.navigate([])
			if (this.source == 'app') {
				//console.log("chiamata script KO GetInfoUser");
				self.postMessage(JSON.stringify({ "type": "KO", payload: { "username": "", "password": "", "message": this.alerts.alert_32 } }), '*');
			}
 			let refDialog =this._alertService.showModalAlertWarning('', `
				<div class='text-center'>
				${this.alerts.alert_32}
				</div>
				`, null,'X');
				this._themeSpinner.hide("body", "body");
		})
	}

	onCFChange() {
		this.user.info.cf = '';
		this.user.info.dataDiNascita = ''
		if (this.drivenName == 'totem' || this.drivenName == 'totem-new')
			setTimeout(() => {
				this.createKeyboard();
			}, 0);
	}
	checkLength(target: string, el?: Element) {
		var value = $(el).val();
		if (value) {
			setTimeout(() => {
				if (target == 'cf')
					if ((value + "").length > 15) {
						let cf16 = (value + "").slice(0, 16);
						if (el) {
							$(el).val(cf16);
							this.user.info.cf = cf16;
						}
					}
				//console.log(value);
				if (target == 'carta')
					if ((value + "").length > 13) {

						let carta113 = (value + "").slice(0, 13);
						if (el) {
							$(el).val(carta113);
							this.codTessera = carta113;
						}
					}
			}, 200)
		}
	}
	checkStringReg(target: string, el?: Element) {

		var value = $(el).val();
		var rS = /[^a-zìéèçòàù ']/gi;
		var rN = /[^0-9]/gi;

		if ((value + "").length > 0) {
			setTimeout(() => {
				if (target == "name") {
					var replaceString = (value + "").replace(rS, "");
					$(el).val(replaceString);
					this.user.info.nome = replaceString;

				}
				if (target == "surname") {
					var replaceString = (value + "").replace(rS, "");
					$(el).val(replaceString);
					this.user.info.cognome = replaceString;
				}
				if (target == "carta") {
					var replaceString = (value + "").replace(rN, "");
					$(el).val(replaceString);
					this.codTessera = replaceString;

				}

			}, 0);
		}
	}
	openDatePicker(datepickerBtn: MatDatepicker<Date>) {
		datepickerBtn.open();
	}
	onBCChange() {
		if (!this.hoBC) this.codTessera = '';
		else { this.user.info.dataDiNascita = ''; this.user.info.cf = '' }
		setTimeout(() => {
			this.createKeyboard();
		}, 0);
	}
	onChangeDate(ddn) {
		if (!ddn) return;
		var date = ddn.split("/")
		var anno = date[2];
		var mese = this.Labels.language == "english" ? Number(date[0]) : Number(date[1]);
		var giorno = this.Labels.language == "english" ? Number(date[1]) : Number(date[0]);
		this.user.info.dataDiNascita = (Number(giorno) > 9 ? giorno : ('0' + giorno)) + "/" + (Number(mese) > 9 ? mese : ('0' + mese)) + "/" + anno;
	}
	onNext() {
		
		const { cf, nome, cognome } = this.user.info;
		//console.log(nome.length)
		this._themeSpinner.show("body", true, "body");
		if (this.findMissingField() != 0) {
			this._themeSpinner.hide("body", "body");
			return;
		}
		if (nome.length > 30 || cognome.length > 30) {
			this._alertService.showModalAlertWarning("", this.alerts.alert_41, null, 'X')
			this._themeSpinner.hide("body", "body");
			return;
		}
		if (this.hoBC) {
			this._channelService.setTask(Task.RegistratiConBC);
			if (this.codTessera.length !== 13 || !this.cartRegExp.test(this.codTessera)) {
				this._alertService.showModalAlertWarning(this.Labels.cardNum, this.Labels.card_tip, null, 'X')
				this._themeSpinner.hide("body", "body");
				return;
			}
		} else
			this._channelService.setTask(Task.RegistratiSenzaBC);


		if (!this.hoBC && !this.nonHoCf) {
			if (!this.cfService.isValidCF(cf)) {
				this._alertService.showModalAlertWarning(this.Labels.control_inserted_fields, this.repleceWith(this.alerts.alert_5, cf), null, 'X')
				this._themeSpinner.hide("body", "body");
				return;
			}
			this.cfService.GNome(nome);
			this.cfService.GCognome(cognome);
			var fc = this.cfService.getCFGenerated()
			var slice = cf.slice(0, 6).toUpperCase();
			if (slice != (fc._cognome + fc._nome).toUpperCase()) {
				this._alertService.showModalAlertWarning(this.Labels.control_inserted_fields, this.alerts.alert_5, null, 'X');
				this._themeSpinner.hide("body", "body");
				return;
			}
			
			var now = new Date();
			let day = this.user.info.cf.slice(9, 11);
			let month = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T'].findIndex(month => month == this.user.info.cf[8].toUpperCase()) + 1;
			let year = this.user.info.cf.slice(6, 8)
			day = Number.parseInt(day) < 40 ? day : (Number.parseInt(day) - 40) + "";
			let prefix = now.getFullYear() - Number.parseInt("19" + year) > 100 ? "20" : "19";
			let dn_test = new Date(Number(prefix + year), Number(month) - 1, Number(day))
			//console.log( "log data nascita REG"+ this.maxDate +" <"+dn_test+( (this.maxDate < dn_test) ? " VERO" : "FALSo"));
			if (this.maxDate < dn_test) {
				this._alertService.showModalAlertWarning(this.Labels.control_inserted_fields, this.alerts.alert_44, null, 'X');
				this._themeSpinner.hide("body", "body");
				return;
			}
		}

		//console.log("log nonHoCF : "+this.nonHoCf);
		this.findCustomer()
			.then((data: { exist: true, userInfo: null }) => {
				if (!data.exist) {
					if (!this.nonHoCf)
						this.FindCF()
							.then(() => {
								this._userService.setUser(this.user);
								this.moveOn();
							})
							.catch(({ type, errorMessage, redirect, label }) => {
								switch (type) {
									case "SERVER":
										this._alertService.showModalAlertWarning("SERVER", errorMessage, null, 'X');
										break;
									case "CF":
										this._alertService.showModalAlertWarning(this.Labels.control_inserted_fields, errorMessage, null, 'X');
										break;
									default:
										this._alertService.showModalAlertWarning("Worning", errorMessage, null, 'X');
								}
							});
					else {
						this._userService.setUser(this.user);
						this.moveOn();
					}
				} else {
					if (this.user.info.anonimo = 'Y') {
						this._userService.nomeAnonimo = nome;
						this._userService.cognomeAnonimo = cognome;
						//console.log("nome : " + nome);
						//console.log("cognome : " + cognome);
						//	this.user.info.nome = nome;
						//	this.user.info.cognome = cognome;
					}
					this._userService.resetUser(data.userInfo);


					this.moveOn();
				}
				this._themeSpinner.hide("body", "body");
			})
			.catch(error => {
				switch (error.type) {
					case "bc_error": {
						this._alertService.showModalAlertWarning(error.label, error.errorMessage, null, 'X');
						break;
					}
					case "login": {
						let refDialog = this._alertService.showModalConfirm(error.label, error.errorMessage, error.ok, error.cancel);
						refDialog.result.then((data) => {
							this.router.navigate(['pages', 'resetPwd']);

						}).catch((error) => {

						})
						break;
					}
					default: {
						this._alertService.showModalAlertWarning("", error.errorMessage, null, 'X');
					}
				}
				this._themeSpinner.hide("body", "body");
			})
	}

	repleceWith(content: string, replacedWith: string): string {
		return content.replace("XXXX", "<strong>" + replacedWith + "</strong>");
	}

	findCustomer() {
		if (!this.nonHoCf && !this.hoBC) {
			var now = new Date();
			let day = this.user.info.cf.slice(9, 11);
			let month = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T'].findIndex(month => month == this.user.info.cf[8].toUpperCase()) + 1;
			let year = this.user.info.cf.slice(6, 8)
			this.user.info.sesso = Number.parseInt(day) < 40 ? "M" : "F";
			day = this.user.info.sesso == "F" ? (Number.parseInt(day) - 40) + "" : day;
			let prefix = now.getFullYear() - Number.parseInt("19" + year) > 100 ? "20" : "19";
			this.user.info.dataDiNascita = Number.parseInt(day) + "/" + month + "/" + prefix + year;
			//dario righe aggiunte
			// let dn_test=new Date(Number(prefix + year), Number(month) - 1, Number(day))
			//  console.log( "log data nascita REG"+ this.maxDate +" <"+dn_test+( (this.maxDate < dn_test) ? " VERO" : "FALSo"));
		}
		var { nome, cognome, dataDiNascita, cf } = this.user.info;
		return new Promise((resolve, reject) => {
			this._customerService.FindConsumer(nome, cognome, dataDiNascita, cf, this.codTessera)
				.then((res: IFindConsumerResponse) => {
					if (res.rowIdCustomer){
						this._userService.customerid = res.rowIdCustomer;
					}
					
					if (res.key){
						this._userService.key=res.key;

					}
					if (res.cardValida.toUpperCase() == "Y"){
						this._userService.codTesseraFind=res.codTessera;
						}
					if (res.username) {
						let Index = res.username.indexOf('@');
						let maskName = res.username.slice(0, 2) + 'XXXX' + res.username.slice(Index, res.username.length);
						reject({
							"type": "login", "errorMessage": this.repleceWith(this.alerts.alert_1, "<br><br><span class=' dark'>" + maskName + "</span>"), "redirect": null, "label": this.Labels.user_exist, "cancel": "X", "ok": this.Labels.reset_pwd
						});
					}
					else if (!this.hoBC && res.codTessera && res.cardValida == 'Y') {
						reject({ "type": "error", email: res.username, "errorMessage": this.alerts.alert_11, "redirect": null, "label": "  BENNET CLUB" });
					}
					else if (this.hoBC && !res.codTessera) {
						reject({ "type": "bc_error", "errorMessage": this.alerts.alert_10, "redirect": null, "label": this.Labels.not_recognized });
					}
					else if (this.hoBC && res.codTessera && res.cardValida == 'N') {
						reject({ "type": "error", "errorMessage": this.alerts.alert_33, "redirect": null, "label": this.Labels.cancel });
					}
					else if (res.rowIdCustomer) {
						if (!this.hoBC)
							this._cardService.GetCustomerListTessere("", res.rowIdCustomer,res.key)
								.then((list: Array<any>) => {
									if (list.length != 0)
										reject({ "type": "error", email: res.username, "errorMessage": this.alerts.alert_11, "redirect": null, "label": "  BENNET CLUB" });
									else
										this._customerService.GetInfoUser(res.rowIdCustomer,"","",res.key)
											.then((userInfo: IInfoUserResponse) => {
												resolve({ exist: true, userInfo: userInfo })
											})
											.catch(() => {
												if (this.source == 'app') {
													//console.log("chiamata script KO GetInfoUser");
													self.postMessage(JSON.stringify({ "type": "KO", payload: { "username": "", "password": "", "message": this.alerts.alert_32 } }), '*');
												}
												reject({ "type": "error", "errorMessage": this.alerts.alert_32, "redirect": null, "label": this.Labels.try });
											})
								}).catch((error) => {
									console.error(error)
									if (this.source == 'app') {
										//console.log("chiamata script KO getCustomerListTesser");
										self.postMessage(JSON.stringify({ "type": "KO", payload: { "username": "", "password": "", "message": this.alerts.alert_32 } }), '*');
									}
									reject({ "type": "error", "errorMessage": this.alerts.alert_32, "redirect": null, "label": this.Labels.try });
								})
						else
							this._customerService.GetInfoUser(res.rowIdCustomer, "", res.codTessera,res.key)
								.then((userInfo: IInfoUserResponse) => {
									resolve({ exist: true, userInfo: userInfo })
								})
								.catch(() => {
									if (this.source == 'app') {
										//console.log("chiamata script KO getInfoUser");
										self.postMessage(JSON.stringify({ "type": "KO", payload: { "username": "", "password": "", "message": this.alerts.alert_32 } }), '*');
									}
									reject({ "type": "error", "errorMessage": this.alerts.alert_32, "redirect": null, "label": this.Labels.try });
								})
					} else {
						resolve({ exist: false });
					}
				}).catch((error) => {
					console.error(error)
					if (this.source == 'app') {
						//console.log("chiamata script KO FindConsumer");
						self.postMessage(JSON.stringify({ "type": "KO", payload: { "username": "", "password": "", "message": this.alerts.alert_32 } }), '*');
					}
					reject({ "type": "error", "errorMessage": this.alerts.alert_32, "redirect": null, "label": this.Labels.try });
				})
		})
	}
	FindCF() {
		var cf = this.user.info.cf;
		return new Promise((resolve, reject) => {
			this._customerService.FindCF(cf)
				.then((data: IFindCFResponse) => {
					if (data.exist) {
						reject({ type: "CF", "errorMessage": this.repleceWith(this.alerts.alert_2, this.user.info.cf), "redirect": null, "label": this.Labels.cancel });
					} else {
						resolve();
					}
				}).catch(() => {
					if (this.source == 'app') {
						//console.log("chiamata script KO FindCF");
						self.postMessage(JSON.stringify({ "type": "KO", payload: { "username": "", "password": "", "message": this.alerts.alert_32 } }), '*');
					}
					reject({ type: "SERVER", "errorMessage": this.alerts.alert_32, "redirect": null, "label": this.alerts.cancel });
				})
		})
	}
	moveOn() {
		this.movedIn = true;
		this.saved = true;
		this.done.emit(true)
	}
	createKeyboard() {
		if (this.drivenName == "totem" || this.drivenName == "totem-new") {
			require.ensure(['app/theme/assets/scripts/VirtualKeyboard.js'], require => {
				var virtualKeyboard = require('app/theme/assets/scripts/VirtualKeyboard.js');
				var keyboard1: IKeyboard = { options: {}, target: null, container: ".PageRegistrationPre" };
				let vk = new virtualKeyboard.default(keyboard1);
				vk.init(".PageRegistrationPre");
			});
		}
	}
	onExit() {
        let refDialog = this._alertService.showModalConfirm(this.Labels.exist, this.alerts.alert_21, this.Labels.exist, 'X', this.topIframe)
        refDialog.result
            .then(data => {
				console.log("this.nexturl"+this.nexturl);
				   if (this.source == "totem-new" || this.source == "totem")
				  window.top.location.reload();
						
				else   if (this.source == 'app'){
					if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
						self.postMessage(JSON.stringify({ "type": "CLOSE", payload: { "username": "", "password": "" } }), '*');
						document.body.classList.remove('modal-open');
						(<any>window).ReactNativeWebView.postMessage('closeWebView');
					}
					else  self.postMessage(JSON.stringify({ "type": "CLOSE", payload: { "username": "", "password": "" } }), '*');
				}				  
				else if (this.nexturl !='') {

                     //window.location.replace(decodeURIComponent(this.initials.loginurl));
                    window.top.location.href = decodeURIComponent(this.nexturl);
                }
                else {
                     if (this.source == "drive")
                        window.location.replace("https://www.bennetdrive.it");
                    if (this.source == "bennet")
                        window.location.replace("https://www.bennet.com");
                    if (this.source != "totem" && this.source == "tablet")
                        this.router.navigate(['pages', 'registrazione'])
                    if (this.source != "totem-new" && this.source == "tablet-new")
                        this.router.navigate(['pages', 'registrazione'])
                    if (this.source == "drive-new")
                        window.top.location.href = "https://www.bennetdrive.it";
                    if (this.source == "instacook")
                        window.top.location.href = "https://www.bennet.com";

                    if (this.source == "bennet-new" || this.source == 'veronesi')
                        window.top.location.href = "https://www.bennet.com";
						 
                     
				}
                
            })
            .catch(data => {
                document.body.classList.remove('modal-open');
            })
    }
	
	/* onRedirectToStamp(email?, codTessera?) {
		this.router.navigate(['pages', 'recuperaBC'], { queryParams: { nome: this.user.info.nome, cognome: this.user.info.cognome, email: email, codTessera: codTessera } })
	}
	onExit() {
		this.router.navigate(['pages'])
	} */


	private scrollToMissingPart(target) {
        var targetInput = $(target);
        if ($(targetInput[0]).offset()) {
            var top = $(targetInput[0]).offset().top;
            var currentScrollBody = $("body").scrollTop();
            if (top < 30) {
                $("body").scrollTop(currentScrollBody + top - 30);
            }
            else {
                if (top > 35) {
                    $("body").scrollTop(top - 30 - currentScrollBody);
                }
            }
        }
    }
	
	findMissingField() {
		let that = this;
		var missing = 0;
		var mux = 0;
		
		$('.PageRegistrationPre').find('.field').each(function () {
			let input = $(this).find('input');
			let matSelect = $(this).find('.mat-select');
			
			if (input.length && input.prop('required')) {
				if (input.val().toString().trim() === "" && !input.prop('disabled')) {
					$(this).find(".hint").addClass("show");
					input.addClass("input-error"); // Aggiunge bordo all'input
					missing++;
					if (mux === 0) {
						mux = 1;
						that.scrollToMissingPart($(this));
					}
				} else {
					$(this).find(".hint").removeClass("show");
					input.removeClass("input-error"); // Rimuove bordo dall'input
				}
			}
			
			if (matSelect.length && matSelect.attr('aria-required') === 'true') {
				let selectedValue = matSelect.find('.mat-select-value').text().trim();
				if (selectedValue === "" && !matSelect.prop('disabled')) {
					$(this).find(".hint").addClass("show");
					matSelect.addClass("input-error"); // Aggiunge bordo al mat-select
					missing++;
					if (mux === 0) {
						mux = 1;
						that.scrollToMissingPart($(this));
					}
				} else {
					$(this).find(".hint").removeClass("show");
					matSelect.removeClass("input-error"); // Rimuove bordo dal mat-select
				}
			}
		});
		
		$('.PageRegistrationPre').find(".missing").each(function () {
			$(this).siblings(".hint").addClass("show");
			$(this).addClass("input-error");
			missing++;
			if (mux === 0) {
				mux = 1;
				that.scrollToMissingPart($(this));
			}
		});
		
		$('.PageRegistrationPre').find(".existed").each(function () {
			$(this).siblings(".hint").removeClass("show");
			$(this).removeClass("input-error");
		});
		
		if (missing != 0) {
			$(".updateAccountPage").scrollTop(0);
		}
		
		return missing;
	}
	

}


// WEBPACK FOOTER //
// ./src/app/theme/components/registration-pre/registration-pre.component.ts